import type { ColumnMetadataTypes } from 'client/js/common/support/utils/eo_types';
import { createSelector } from 'reselect';
import { getDynamicCalculationId } from '../../../../../shared/constants/dynamicMetrics';
import type { DynamicCalculationId } from '../../../../../shared/types/dynamicMetrics';
import { buildColumn } from '../../../common/support/utils';
import type { IColumn } from '../../../common/types/IColumn';
import type { ColumnOptions, GetColumnKeys, GetColumnOptions } from './createColumnsSelector.types';

export const DYNAMIC_CALCULATION_METADATA_TYPE: { [Key in DynamicCalculationId]: keyof ColumnMetadataTypes } = {
  cost_per: 'currency_formula',
  installs_per: 'percentage',
  rate_for: 'percentage',
  revenue_per: 'currency_formula',
  roas_per: 'percentage',
};

export const getDynamicCalculationColumns = (calculationKeys: string[], options?: ColumnOptions): IColumn[] => {
  return calculationKeys.map((key) => {
    const calculationId = getDynamicCalculationId(key);
    const columnType = calculationId ? DYNAMIC_CALCULATION_METADATA_TYPE[calculationId] : 'percentage';
    return buildColumn({ type: columnType, key, ...options });
  });
};

export const createDynamicCalculationColumnsSelector = (
  getCalculationKeys: GetColumnKeys,
  getColumnOptions: GetColumnOptions = () => undefined
) => {
  return createSelector(getCalculationKeys, getColumnOptions, getDynamicCalculationColumns);
};
